import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    sessionId: String,
    pagePath: String,
    pageTitle: String,
    referrer: String,
    userId: String
  }

  connect() {
    this.sent = false
    this.startTime = Date.now()

    // Send initial record quickly (captures quick visits)
    setTimeout(() => {
      this.sendAnalytics()
    }, 500)

    // Update duration on page unload
    window.addEventListener('beforeunload', this.handleUnload)
  }

  disconnect() {
    window.removeEventListener('beforeunload', this.handleUnload)
  }

  handleUnload = () => {
    this.sendAnalytics(true)
  }

  sendAnalytics(isUnload = false) {
    const endTime = Date.now()
    const duration = Math.round((endTime - this.startTime) / 1000)

    // On unload, only re-send if we've been on the page > 2s (to update duration)
    if (this.sent && !isUnload) return
    if (this.sent && isUnload && duration < 2) return

    const data = {
      session_id: this.sessionIdValue || this.generateSessionId(),
      page_path: this.pagePathValue || window.location.pathname,
      page_title: this.pageTitleValue || document.title,
      referrer: this.referrerValue || document.referrer,
      user_id: this.userIdValue || null,
      ip_address: null,
      user_agent: navigator.userAgent,
      visit_start: new Date(this.startTime).toISOString(),
      visit_end: new Date(endTime).toISOString(),
      duration_seconds: duration,
      language: navigator.language,
      screen_resolution: `${screen.width}x${screen.height}`,
      device_type: this.getDeviceType(),
      browser: this.getBrowser(),
      os: this.getOS()
    }

    if (isUnload && navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify({ analytics: data })], { type: 'application/json' })
      navigator.sendBeacon('/api/update', blob)
    } else {
      fetch('/api/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ analytics: data }),
        keepalive: true
      }).catch(() => {})
    }

    this.sent = true
  }

  generateSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id')
    if (!sessionId) {
      sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
      sessionStorage.setItem('analytics_session_id', sessionId)
    }
    return sessionId
  }

  getDeviceType() {
    const width = window.innerWidth
    if (width <= 768) return 'Mobile'
    if (width <= 1024) return 'Tablet'
    return 'Desktop'
  }

  getBrowser() {
    const ua = navigator.userAgent
    if (ua.includes('Chrome')) return 'Chrome'
    if (ua.includes('Firefox')) return 'Firefox'
    if (ua.includes('Safari')) return 'Safari'
    if (ua.includes('Edge')) return 'Edge'
    return 'Unknown'
  }

  getOS() {
    const ua = navigator.userAgent
    if (ua.includes('Windows')) return 'Windows'
    if (ua.includes('Mac')) return 'macOS'
    if (ua.includes('Linux')) return 'Linux'
    if (ua.includes('Android')) return 'Android'
    if (ua.includes('iOS')) return 'iOS'
    return 'Unknown'
  }
}